---
en:
  email:
    body:
      task_assigned: A new task related to %{power_plant} (%{company}) has been assigned for you.
      yield_loss: 'Yield loss:'
    data_export_error:
      body: Your data export request could not be completed because exchange rate data is missing for the selected period and currency.
      contact_support: Please contact support for assistance.
      error_details: 'Error details: %{message}'
      greeting: Hi %{name},
    footer:
      auto_generated: This email was auto generated.
      here: here
      kaiasolutions_staff: Portal staff
      notifications: More information on the %{portal_href}.
      notifications_plain: You received this notification because you have access to the %{brand}.
      portal_href: Portal O&M Dashboard
      regards: Regards
    heading:
      greeting: Hi
    subjects:
      data_export_error: Data export failed
      immediate_notifications: Portal - Immediate notifications for "%{notification_rule_name}"
      periodic_notifications: Portal - notifications "%{notification_rule_name}"
      task_assigned: Task assigned
